
export const environment = {
    production: false,
    environment: 'dev',
    apiBaseUrl: 'https://dev3cxreporting.ringoffice.com/api/api',
    imageBaseUrl: 'https://dev3cxreporting.ringoffice.com/api/uploads',
    recaptchaSiteKey: '6LdVnawrAAAAACtn4JtEA-HKTA6hFJ5AlXPB4X8y'
};
